export enum EScenario {
    Default = 0,
    Home = 1,
    Home2 = 2,
    Explode = 3,
    Temperature = 4,
    Metrics = 5
}